@charset "UTF-8";

/* src/app/shared/components/ngx-responsive-table/components/toggle-switch/toggle-switch.component.scss */
.toggle-switch {
  cursor: pointer;
}
.toggle-switch::after {
  content: "\203a";
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
  transform-origin: center;
  display: block;
}
.toggle-switch.is-on::after {
  transform: rotateZ(-90deg) rotateX(-180deg);
}
/*# sourceMappingURL=toggle-switch.component.css.map */
